module.exports = "<p>\n  institution works!\n</p>\n"